import React, { lazy } from 'react';
const bonuses = [{
  title: 'Full Season Planner',
  desc: '12-month visual calendar + weekly planning sheets.',
  value: '$59',
  img: 'https://cdn.magicpatterns.com/uploads/vsWpZMdp2qPTX8Lcjk8zr4/Bono_1..webp'
}, {
  title: '30 Practice Session Templates',
  desc: 'Ready-to-use blank session sheets with court diagrams.',
  value: '$54',
  img: 'https://cdn.magicpatterns.com/uploads/hJWTidCGAcb1su7i97hb3Z/boNO_2..webp'
}, {
  title: 'Tactical Playbook — 30 Set Plays',
  desc: 'Complete plays with diagrams — offense, defense and special situations.',
  value: '$79',
  img: 'https://cdn.magicpatterns.com/uploads/dDaH8CgdsJqD1NMkbRqTgE/BONO_3..webp'
}, {
  title: 'Player Evaluation System',
  desc: 'Complete assessment toolkit with forms, trackers and parent reports.',
  value: '$64',
  img: 'https://cdn.magicpatterns.com/uploads/oNrJ3sWNnnq83HwPP3myPu/Bono_4..webp'
}, {
  title: 'Warm-Up & Activation Bible',
  desc: 'Warm-up and cool-down routines for all ages and situations.',
  value: '$72',
  img: 'https://cdn.magicpatterns.com/uploads/4LUxPsjP3cPpL64ccgcC3M/bono_5..webp'
}];
export function BonusSection() {
  return <section className="w-full bg-[#0A0A0A] py-16 px-4" data-id="element-1">
      <div className="max-w-4xl mx-auto" data-id="element-2">
        <div className="text-center mb-12" data-id="element-3">
          <h2 className="text-3xl sm:text-5xl font-black text-white mb-4 tracking-tight" data-id="element-4">
            🎁 You Also Get{' '}
            <span className="text-[#6B2FB3]" data-id="element-5">5 Strategic Bonuses</span>
          </h2>
          <p className="text-[#B0B0C0] text-lg font-medium mb-5" data-id="element-6">
            Included at no extra cost
          </p>
          <span className="inline-flex items-center gap-2 bg-[#16161F] border border-[#6B2FB333] rounded-full px-5 py-2.5 text-sm sm:text-base font-bold" data-id="element-7">
            <span className="text-[#B0B0C0]" data-id="element-8">Real value:</span>
            <span className="text-[#6B2FB3] line-through" data-id="element-9">$328</span>
            <span className="text-[#B0B0C0]" data-id="element-10">— today included</span>
            <span className="text-[#00C853] font-black uppercase tracking-wider" data-id="element-11">
              FREE
            </span>
          </span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-12">
          {bonuses.map((bonus, i) => <div key={i} className={`bg-[#16161F] border border-[#6B2FB333] rounded-2xl p-5 flex flex-col ${i === 4 ? 'sm:col-span-2 sm:max-w-md sm:mx-auto w-full' : ''}`} data-id="element-13">
              <div className="relative mb-4 rounded-xl overflow-hidden bg-[#0A0A0A]" data-id="element-14">
                <img src={bonus.img} alt={bonus.title} loading="lazy" className="w-full h-48 object-cover" width={1024} height={1024} data-id="element-15" />
              </div>
              <div className="flex items-center justify-between mb-3" data-id="element-16">
                <span className="text-[#6B2FB3] font-black text-sm tracking-wider uppercase" data-id="element-17">
                  Bonus 0{i + 1}
                </span>
                <span className="inline-flex items-center gap-1.5 bg-[#00C853]/10 text-[10px] font-black px-2.5 py-1 rounded-full uppercase tracking-wider" data-id="element-18">
                  <span className="text-[#6B2FB3] line-through" data-id="element-19">
                    {bonus.value}
                  </span>
                  <span className="text-[#00C853]" data-id="element-20">FREE</span>
                </span>
              </div>
              <h4 className="text-white font-bold text-lg mb-2 leading-tight" data-id="element-21">
                {bonus.title}
              </h4>
              <p className="text-[#B0B0C0] text-sm font-medium leading-relaxed" data-id="element-22">
                {bonus.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}